import { SRILANKAN_COUNTRY_CODE } from '../../shared/constants/constants';

export const alterPhoneNumber = phoneNumber => {
  return SRILANKAN_COUNTRY_CODE.concat(phoneNumber);
};
